import React, { cloneElement } from "react";
import { RCCLov } from "react-common-components";
import ILovComponent from "react-common-components/dist/components/Lov/interface";
import Photo from "src/components/Photo";
import { useTranslation } from "src/context/Translations/context";

const LovUsers: React.FC<Omit<ILovComponent, "valueProperty" | "labelProperty" | "routeAPI">> = ({
	name,
	control,
	label,
	...rest
}) => {
	const { translate } = useTranslation();
	const { REACT_APP_S3_ADDRESS, REACT_APP_S3_DIRECTORY } = process.env;
	const optionComponent = (component:any,props:any) =>  cloneElement(
		component,
		props,
		<div style={{ display: "flex" }}>
			<Photo 
				width={28}
				height={28}
				hover={false}
				name={props.data.label||""}
				link={props.data.extendedProps.efa005Imagem && `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${props.data.extendedProps.efa005Imagem}`}
			/> 
			<div style={{ display: "flex", flexDirection: "column"}}>
				{props.data.label}
				<small>{props.data.extendedProps.efa005Email}</small>
			</div>
		</div>
	);

	return(
		<RCCLov 
			label={label}
			name={name} 
			control={control}
			routeAPI="User/Lov"
			valueProperty="Efa005Id"
			labelProperty="Efa005Nome"
			elementsPerPage={20}
			componentsFunctions={{option:(x,y) => optionComponent(x,y)}}
			placeholder={translate("Digite para filtrar as opções")}
			{...rest}
		/>
	);};

export default LovUsers;
